import logo2 from '../img/image.png';
import logo from '../img/logo.jpg';

export default  {
    logo2,
    logo
};